import { render, staticRenderFns } from "./ProjectMessages.vue?vue&type=template&id=1ebab6f2&scoped=true"
import script from "./ProjectMessages.vue?vue&type=script&lang=js"
export * from "./ProjectMessages.vue?vue&type=script&lang=js"
import style0 from "./ProjectMessages.vue?vue&type=style&index=0&id=1ebab6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebab6f2",
  null
  
)

export default component.exports